/** Remove duplicate dimension keys while preserving order. */
const dedupeDimensions = (dimensions) => {
  const seen = new Set();
  return (dimensions || []).filter((key) => {
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export default dedupeDimensions;
